// extracted by mini-css-extract-plugin
module.exports = {"root":"videoCall_root__2e3z8"};